import type React from "react";
import { ActionIcon, Group, Tooltip } from "@mantine/core";
import { Table } from "@xplatform/design-system";
import {
  IconCheck,
  IconRotateClockwise,
  IconX,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

interface TmRowActionsProps {
  hasTopMatch: boolean;
  actionsDisabled: boolean;
  isSaving: boolean;
  isRejected: boolean;
  onAccept: () => void;
  onReject: () => void;
  onRecover: () => void;
}

/** The same per-row controls work in the row table and in batch file cards. */
export const TmRowActionButtons: React.FC<TmRowActionsProps> = ({
  hasTopMatch,
  actionsDisabled,
  isSaving,
  isRejected,
  onAccept,
  onReject,
  onRecover,
}) => {
  const { t } = useTranslation();

  return (
    <Group gap={4} wrap="nowrap" justify="flex-start">
        <Tooltip label={t("resultRow.actions.accept")}>
          <ActionIcon
            size="sm"
            variant="light"
            color="teal"
            onClick={onAccept}
            disabled={!hasTopMatch || actionsDisabled || isRejected}
            loading={isSaving}
            aria-label={t("resultRow.actions.accept")}
          >
            <IconCheck size={14} />
          </ActionIcon>
        </Tooltip>
        {isRejected ? (
          <Tooltip
            label={t("resultRow.actions.recover", { defaultValue: "Recover" })}
          >
            <ActionIcon
              size="sm"
              variant="light"
              color="blue"
              onClick={onRecover}
              disabled={actionsDisabled}
              loading={isSaving}
              aria-label={t("resultRow.actions.recover", {
                defaultValue: "Recover",
              })}
            >
              <IconRotateClockwise size={14} />
            </ActionIcon>
          </Tooltip>
        ) : (
          <Tooltip label={t("resultRow.actions.reject")}>
            <ActionIcon
              size="sm"
              variant="light"
              color="red"
              onClick={onReject}
              disabled={actionsDisabled}
              loading={isSaving}
              aria-label={t("resultRow.actions.reject")}
            >
              <IconX size={14} />
            </ActionIcon>
          </Tooltip>
        )}
    </Group>
  );
};

const TmRowActions: React.FC<TmRowActionsProps> = (props) => (
  <Table.Td>
    <TmRowActionButtons {...props} />
  </Table.Td>
);

export default TmRowActions;
